export default __webpack_public_path__ + "static/media/how-to-pass.ea23b8ab.png";